var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpinaryLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 641.3 312.5",
    style: {
      enableBackground: "new 0 0 641.3 312.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#FFFFFF;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.7,224.9c-5.7-3.7-10-8.8-12.9-15.2c-2.9-6.5-4.4-13.8-4.4-21.9s1.5-15.5,4.4-22.1 c2.9-6.6,7.3-11.7,13-15.5s12.5-5.6,20.5-5.6c7.9,0,14.6,1.9,20.3,5.6c5.7,3.7,10,8.9,12.9,15.4c2.9,6.5,4.4,14,4.4,22.3 c0,8.2-1.5,15.6-4.4,22c-2.9,6.4-7.2,11.5-12.9,15.1s-12.4,5.5-20.3,5.5C127.2,230.4,120.3,228.6,114.7,224.9z M148.3,215.2 c3.7-2.7,6.6-6.4,8.6-11.2c2-4.8,3-10.2,3-16.4s-1-11.6-3-16.4s-4.8-8.6-8.6-11.4c-3.7-2.8-8.1-4.2-13.2-4.2s-9.5,1.4-13.2,4.2 s-6.6,6.6-8.6,11.4c-2,4.8-3,10.3-3,16.3s1,11.4,3,16.2s4.8,8.6,8.6,11.3c3.7,2.7,8.1,4.1,13.2,4.1 C140.1,219.3,144.6,217.9,148.3,215.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.9,150.4c4.4,2.7,7.5,6.1,9.5,10.4c2,4.2,3,8.7,3,13.4c0,4.7-1,9.1-3,13.2s-5.2,7.5-9.5,10.2 c-4.4,2.7-9.9,4-16.7,4h-17.1v28.1h-12v-83.3h29.1C224,146.3,229.6,147.7,233.9,150.4z M229.1,187.3c3.6-2.5,5.5-6.9,5.5-13.1 s-1.8-10.5-5.5-13c-3.6-2.5-8.1-3.8-13.4-3.8h-15.5v33.7h15.5C220.9,191.1,225.4,189.8,229.1,187.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.4,146.3h12.5v83.3h-12.5V146.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290,146.3h14l41.2,63.9h0.4v-63.9h12.2v83.3h-14.3L302.6,167h-0.4v62.6H290L290,146.3L290,146.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.7,206.7h-32.2l-8,23H371l30.8-83.3h11.7l30.9,83.3h-12.5L423.7,206.7z M420.3,196.9l-12.5-35h-0.6 l-12.2,35H420.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.2,197.4h-13.7v32.2h-12.2v-83.3h29.1c6.7,0,12.3,1.2,16.7,3.8c4.4,2.5,7.5,5.7,9.5,9.6c2,3.9,3,8,3,12.4 c0,5.7-1.6,10.8-4.9,15.4c-3.2,4.5-8.2,7.5-15,9l20.9,33.2h-13.3L483.2,197.4z M469.5,187h15.2c5.3,0,9.8-1.1,13.4-3.4 s5.5-6.1,5.5-11.6c0-5.4-1.8-9.2-5.5-11.4c-3.6-2.2-8.1-3.3-13.4-3.3h-15.2V187z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M553.3,229.7v-29.9L526,146.3h13.2l19.8,40.3h0.8l19.6-40.3h13.2l-27.1,53.5v29.7L553.3,229.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "259.5,44.6 61.1,44.6 48.6,44.6 48.6,57.1 48.6,255.4 48.6,267.9 61.1,267.9 271.9,267.9 271.9,255.4 61.1,255.4 61.1,57.1 259.5,57.1 259.5,120.6 271.9,120.6 271.9,57.1 271.9,44.6 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpinaryLogo);
export default __webpack_public_path__ + "static/media/opinary-logo.18f41d207992119a9141a0cef2abcd87.svg";
export { ForwardRef as ReactComponent };